exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* stylelint-enable */\n", ""]);

// exports
exports.locals = {
	"blue-base": "#005091",
	"blue-light": "#006cc4",
	"blue-x-light": "#005eab",
	"blue-dark": "#00345e",
	"red-base": "#ea0100",
	"red-light": "#ff1f1e",
	"red-x-light": "#ff0605",
	"red-dark": "#b70100",
	"dark-base": "#444",
	"dark-light": "#5e5e5e",
	"dark-dark": "#2b2b2b",
	"background-base": "#fff",
	"background-light": "white",
	"background-dark": "#e6e6e6",
	"greyLight-base": "#dadada",
	"greyLight-light": "#f4f4f4",
	"greyLight-x-light": "#e7e7e7",
	"greyLight-dark": "#c1c1c1",
	"greySky-base": "#efefef",
	"greySky-light": "white",
	"greySky-x-light": "#fcfcfc",
	"greySky-dark": "#d6d6d6",
	"positive-base": "#093",
	"positive-light": "#00cc44",
	"positive-dark": "#006622",
	"negative-base": "#ea0100",
	"negative-light": "#ff1f1e",
	"negative-x-light": "#ff0605",
	"negative-dark": "#b70100",
	"warning-base": "#f6bb14",
	"warning-light": "#f8c945",
	"warning-dark": "#cf9b08",
	"info-base": "#005091",
	"info-light": "#006cc4",
	"info-dark": "#00345e",
	"star-base": "#ffd201",
	"star-light": "#ffdb34",
	"star-dark": "#cda900",
	"facebook-base": "#3a5a98",
	"facebook-light": "#4b71ba",
	"facebook-dark": "#2c4473",
	"youtube-base": "#f00",
	"youtube-light": "#ff3333",
	"youtube-dark": "#cc0000",
	"rxgreen-base": "#34cb9e",
	"rxgreen-light": "#5dd5b1",
	"rxgreen-x-light": "#48d0a8",
	"rxgreen-dark": "#2aa27e",
	"now-base": "#093",
	"now-light": "#00cc44",
	"now-dark": "#006622",
	"sky-blue-base": "#e6edf3",
	"sky-blue-light": "white",
	"sky-blue-dark": "#c4d4e2",
	"twitter-base": "#55acee",
	"twitter-light": "#83c3f3",
	"twitter-dark": "#2795e9",
	"pinterest-base": "#bd081c",
	"pinterest-light": "#ee0a23",
	"pinterest-dark": "#8c0615",
	"google-base": "#d34836",
	"google-light": "#dc6e60",
	"google-dark": "#b03626",
	"grey-base": "#adadad",
	"grey-light": "#c7c7c7",
	"grey-dark": "#949494",
	"whatsapp-base": "#25d366",
	"whatsapp-light": "#4be083",
	"whatsapp-dark": "#1da851"
};